import { createFileRoute } from "@tanstack/react-router";
import { RootCompanyEditor } from "@/rootCompanies/RootCompanyEditor";
import { parseRootCompaniesSearch } from "@/rootCompanies/rootCompaniesSearch";

export const Route = createFileRoute(
  "/_authenticated/platform-management_/companies_/new",
)({ validateSearch: parseRootCompaniesSearch, component: NewCompanyRoute });

function NewCompanyRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RootCompanyEditor
      onBack={() => {
        void navigate({ to: "/platform-management/companies", search });
      }}
    />
  );
}
